module.exports = {
  "country": "SM",
  "artist": "Senhit feat. Flo Rida",
  "song": "Adrenalina",
  "year": "2021",
  "place": "22",
  "spotify": "5sckZhskSmeF8TFJ05oSCB"
};